import React from "react";
import { HoldBalance } from "./components/HoldBalance";
import { InventorySummary } from "./components/InventorySummary";
import { SaleSummary } from "./components/SaleSummary";
import { PageLayout } from "src/components/shopify/PageLayout";
import { Layout } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import { FulFilmentRate } from "./components/FulFilmentRate";

export function DashboardScreen() {
  const { t } = useTranslation();
  return (
    <PageLayout
      pageProp={{
        title: t("page_dashboard.title"),
      }}
    >
      <Layout>
        <HoldBalance />
        <Layout.Section variant="fullWidth">
          <hr />
        </Layout.Section>
        {/* <Layout.Section>
          <hr />
        </Layout.Section> */}
        <InventorySummary />
        <div>
          <SaleSummary />
          <FulFilmentRate />
        </div>
      </Layout>
    </PageLayout>
  );
}
